import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { RootState, setCurrentUserCampus, setCurrentUserCampusId } from "../globals";

/*
	Enlaces de los avisos de Cliq (Esteban, 2026-09-25): /enrollmentRequests?solicitud=27&plantel=4
	o /paymentIntents?ticket=21&plantel=4. Primero cambia al plantel del enlace (si la persona lo
	tiene), luego abre esa solicitud o ese ticket, y limpia la dirección para que al recargar no se
	vuelva a abrir. Igual que los enlaces de Horarios. Se limpia con el router (no con history a mano) para que la app
	también sepa que ya no está; el «rol=» se deja: lo consume app.tsx (cambio de rol del enlace).
*/
const direccionLimpia = (): string => {
	const rol = new URLSearchParams(window.location.search).get("rol");
	return window.location.pathname + (rol ? "?rol=" + encodeURIComponent(rol) : "");
};
/*
	El aviso («El enlace es de un plantel al que no tienes acceso.») lo guarda el propio hook y la pantalla lo enseña aparte: si se
	mandaba al «error» de la pantalla, la carga de la lista lo borraba al instante (setError(null)) y nunca se veía (QA 2026-10-09).
*/
export const useEnlaceDirecto = (param: string, abrir: (id: number) => void, avisar?: (texto: string) => void): { aviso: string | null; cerrar: () => void } => {
	const [aviso, setAviso] = useState<string | null>(null);
	const dispatch = useDispatch();
	const campusRef: any = useSelector((state: RootState) => state.campusRef.value);
	const currentUserCampus: any = useSelector((state: RootState) => state.currentUserCampus.value);
	const atendido = useRef(false);
	const navigate = useNavigate();

	useEffect(() => {
		if (atendido.current || !campusRef || !currentUserCampus) {
			return;
		}
		const q = new URLSearchParams(window.location.search);
		const id = Number(q.get(param) || 0);
		const plantel = Number(q.get("plantel") || 0);
		if (!id && !plantel) {
			atendido.current = true;
			return;
		}
		if (plantel > 0 && campusRef[currentUserCampus]?.id !== plantel) {
			if (campusRef["C_" + plantel] == null) {
				atendido.current = true;
				navigate(direccionLimpia(), { replace: true });
				setAviso("El enlace es de un plantel al que no tienes acceso.");
				avisar?.("El enlace es de un plantel al que no tienes acceso.");
				return;
			}
			//Al cambiar el plantel este efecto vuelve a correr y ya abre lo enlazado.
			dispatch(setCurrentUserCampusId(plantel));
			dispatch(setCurrentUserCampus("C_" + plantel));
			return;
		}
		atendido.current = true;
		navigate(direccionLimpia(), { replace: true });
		if (id > 0) {
			abrir(id);
		}
	}, [campusRef, currentUserCampus]);
	return { aviso, cerrar: () => setAviso(null) };
};

export default useEnlaceDirecto;
